import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getTipos } from 'api/catalogos';

// eslint-disable-next-line react/prop-types
const Tipos = ({ permission }) => (
  <PlainCRUD
    title="Tipos"
    permission={permission}
    get={() => getTipos(null, false)}
    fields={[
      defaultFields.clave,
      {
        name: 'denominacion',
        label: 'Denominacion',
        colWidth: 300,
        ellipsis: true,
      },
      {
        name: 'nivel',
        label: 'Nivel',
        colWidth: 200,
      },
    ]}
    tableProps={{ expandable: true }}
    readOnly
  />
);

export default Tipos;
